export const DEAL_CATEGORY_IDS = {
  INVOICE_FINANCING: "DCT1000001",
  JOINT_VENTURES: "DCT1000002",
  STARTUP_FUNDING: "DCT1000003",
  SUPPLY_CHAIN_FINANCE: "DCT1000006",
};

export const PRODUCT_GROUPS = {
  FINANCING: "financing",
  VENTURES: "ventures",
  EQUITY: "equity",
};

/** Top-level choices shown on enroll / new enquiry */
export const PRODUCT_GROUP_OPTIONS = [
  {
    key: PRODUCT_GROUPS.FINANCING,
    label: "Financing",
    dealCategoryId: null,
    requiresSubCategory: true,
  },
  {
    key: PRODUCT_GROUPS.VENTURES,
    label: "Ventures",
    dealCategoryId: DEAL_CATEGORY_IDS.JOINT_VENTURES,
    requiresSubCategory: false,
  },
  {
    key: PRODUCT_GROUPS.EQUITY,
    label: "Equity",
    dealCategoryId: DEAL_CATEGORY_IDS.STARTUP_FUNDING,
    requiresSubCategory: false,
  },
];

export const FINANCING_SUBCATEGORY_IDS = [
  DEAL_CATEGORY_IDS.INVOICE_FINANCING,
  DEAL_CATEGORY_IDS.SUPPLY_CHAIN_FINANCE,
];

export const DEAL_CATEGORY_DISPLAY_NAMES = {
  [DEAL_CATEGORY_IDS.INVOICE_FINANCING]: "Invoice Financing",
  [DEAL_CATEGORY_IDS.JOINT_VENTURES]: "Ventures",
  [DEAL_CATEGORY_IDS.STARTUP_FUNDING]: "Equity",
  [DEAL_CATEGORY_IDS.SUPPLY_CHAIN_FINANCE]: "Supply Chain Financing",
};

export function getDealCategoryDisplayName(dealCategoryId, fallbackName = "") {
  return DEAL_CATEGORY_DISPLAY_NAMES[dealCategoryId] || fallbackName || "";
}

export function isInvoiceStyleCategory(dealCategoryId) {
  return (
    dealCategoryId === DEAL_CATEGORY_IDS.INVOICE_FINANCING ||
    dealCategoryId === DEAL_CATEGORY_IDS.SUPPLY_CHAIN_FINANCE
  );
}

export function isSupplyChainCategory(dealCategoryId) {
  if (!dealCategoryId) return false;
  if (dealCategoryId === DEAL_CATEGORY_IDS.SUPPLY_CHAIN_FINANCE) return true;
  const normalized = String(dealCategoryId).toLowerCase().replace(/[\s_-]+/g, "");
  return (
    normalized === "dct1000006" ||
    normalized.includes("supplychain")
  );
}

export function isVenturesCategory(dealCategoryId) {
  return dealCategoryId === DEAL_CATEGORY_IDS.JOINT_VENTURES;
}

export function isEquityCategory(dealCategoryId) {
  return dealCategoryId === DEAL_CATEGORY_IDS.STARTUP_FUNDING;
}

export function getFinancingSubcategoryOptions(categories = []) {
  return (categories || [])
    .filter((category) =>
      FINANCING_SUBCATEGORY_IDS.includes(category.dealCategoryId),
    )
    .map((category) => ({
      value: category.dealCategoryId,
      label: getDealCategoryDisplayName(
        category.dealCategoryId,
        category.dealCategoryName,
      ),
    }));
}

export function getProductGroupOptions() {
  return PRODUCT_GROUP_OPTIONS.map((option) => ({
    value: option.key,
    label: option.label,
  }));
}

export function resolveDealCategoryIdForProductGroup(productGroup) {
  const option = PRODUCT_GROUP_OPTIONS.find((item) => item.key === productGroup);
  return option?.dealCategoryId || null;
}
